window.hoculus = window.hoculus || {};
if (console && console.log) {
	console.log(
		"Coded by %cHoculus srl %con %cShopify %c- %c" +
		Shopify.theme.name +
		" %c -> https://hoculus.com",
		"color: red; font-weight: bold",
		"color: unset",
		"color: green",
		"color: unset",
		"color: blue",
		"color: unset; font-weight: bold"
	);
}

hoculus.utils = class {
	static debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}

	static setCookie(name, value, minutes) {
		var expires = "";
		if (minutes) {
			var date = new Date();
			date.setTime(date.getTime() + (minutes * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	};

	static getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	};

	static async domreadyState() {
		return await new Promise(function (resolve, reject) {
			document.onreadystatechange = () => {
				if (document.readyState === "complete") {
					resolve(true);
				}
			};
		});
	}

	static async getScriptAsync(source, isModule = false, isNoModule = false) {
		return await new Promise(function (resolve, reject) {
			hoculus.loadedScripts = hoculus.loadedScripts || [];
			if (hoculus.loadedScripts.includes(source) || source == "") {
				resolve(true);
			} else {
				var script = document.createElement("script");
				var prior = document.getElementsByTagName("script")[0];

				script.defer = 1;
				
				if (isModule) script.type = "module";
				if (isNoModule) script.noModule = 1;

				script.onload = script.onreadystatechange = function (_, isAbort) {
					if (
						isAbort ||
						!script.readyState ||
						/complete/.test(script.readyState)
					) {
						script.onload = script.onreadystatechange = null;
						script = undefined;

						if (!isAbort) setTimeout(resolve(true), 50);
					}
				};

				script.src = source;
				prior.parentNode.insertBefore(script, prior);
			}
		});
	}

	static async getCssAsync(css) {
		hoculus.inProgressAssets = hoculus.inProgressAssets || [];
		hoculus.loadedAssets = hoculus.loadedAssets || [];

		return await new Promise(function (resolve, reject) {
			if (hoculus.loadedAssets.includes(css) || css == "") return resolve(true);

			if (hoculus.inProgressAssets.includes(css)) resolve(true);
			else {
				hoculus.inProgressAssets.push(css);

				// Generate link tag
				let link = document.createElement("link");
				link.setAttribute("rel", "stylesheet");
				link.setAttribute("href", css);

				link.onload = function () {
					hoculus.loadedAssets.push(css);
					resolve(true);
				};

				link.onerror = function () {
					hoculus.inProgressAssets.splice(hoculus.inProgressAssets.indexOf(css), 1);
					reject("CSS not loaded");
				};

				document.head.appendChild(link);
			}
		});
	}

	static asyncAssetsInterval(css, resolve, reject) {
		var maxAttempts = 100;
		var attempts = 0;
		var interval = setInterval(function () {
			attempts += 1;

			if (hoculus.loadedAssets && hoculus.loadedAssets.includes(css)) {
				clearInterval(interval);
				resolve(true);
				return;
			}

			if (!hoculus.inProgressAssets || !hoculus.inProgressAssets.includes(css)) {
				clearInterval(interval);
				reject("CSS not loaded");
				return;
			}

			if (attempts >= maxAttempts) {
				clearInterval(interval);
				reject("CSS load timeout");
			}
		}, 50);
	}

	static onInteraction() {
		hoculus.interacted = hoculus.interacted || false;
		if (hoculus.interacted == false) {
			console.log("Interacted");
			["click", "scroll", "touchstart", "mousemove"].forEach(function (evt) {
				document.removeEventListener(evt, hoculus.utils.onInteraction)
			})
			hoculus.onInteractionCallback();
			hoculus.interacted = true;
		}
	}
}

hoculus.Gorgias = function() {
	const footer = document.querySelector(".main-footer");
	const gorgiasWidget = document.querySelector("#gorgias-chat-container #chat-button");
	if (!window.hoculus.settings?.scroll?.hideWidgetsOnFooter || !footer || !gorgiasWidget) return;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				gorgiasWidget.style.transform = "translateX(150%)";
			} else {
				gorgiasWidget.style.transform = "translateX(0)";
			}
		});
	}, { threshold: 0.1 });

	observer.observe(footer);
}

window.hoculus['swiper-slider'] = class extends HTMLElement {
    constructor() {
        super();
    }

    loadSwiper() {
        return new Promise(async (resolve, reject) => {
            try {
                await Promise.all([
                    window.hoculus.utils.getCssAsync(window.hoculus.settings.swiper.css),
                    window.hoculus.utils.getScriptAsync(window.hoculus.settings.swiper.js)
                ]);
                resolve();
            } catch(err) {
                console.log(err);
                reject();
            };
        });
    }
}

hoculus.utils.domreadyState().then(async () => {
    customElements.define('hoculus-swiper-slider', window.hoculus['swiper-slider']);
	hoculus.Gorgias();
});